import React, { useEffect, useState } from 'react';
import Heading from '../../common/Heading/Heading';
import {
  App,
  Space,
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Select,
  Spin,
  Collapse,
  Descriptions,
  Flex,
  Divider,
  Checkbox,
  Radio,
  Dropdown,
} from 'antd';
import {
  CheckOutlined,
  CloseCircleOutlined,
  DeleteOutlined,
  DollarOutlined,
  DownOutlined,
  EditOutlined,
  FileTextOutlined,
  PlusOutlined,
} from '@ant-design/icons';
import { useNavigate, useParams } from 'react-router-dom';
import {
  addMaterialRequest,
  cancelMaterialRequest,
  getItemDetails,
  getStockItems,
  submitMaterialRequest,
  updateMaterialRequest,
} from '../../../network/materialRequest';
import { queryKeys } from '../../../services/react-query/queryKeys';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getWarehouse } from '../../../network/warehouse';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import { getVATDetails } from '../../../network/purchaseOrder';
import {
  getGetDetailsApi,
  getSearchApi,
  getSearchApiSearchText,
} from '../../../network/itemList';
import { getSearchPatients } from '../../../network/appointment';
import ItemOrderList from '../AddPurchaseOrder/ItemOrderList';
import TaxtList from '../AddPurchaseOrder/TaxtList';
import PaymentSchedule from '../AddPurchaseOrder/PaymentSchedule';
import {
  addSalesOrder,
  getSalesOrderById,
  updateSalesOrder,
} from '../../../network/salesOrder';
import { getCustomer } from '../../../network/customer';
import SalesTeamList from './SalesTeamList';
import { ModalAddAmount, ModalTodoList } from '../ModalApp/ModalApp';
import { MdAssignmentAdd } from 'react-icons/md';
import HeadingApp from '../../../hooks/HeadingApp';
import { FaCartPlus, FaFileInvoice, FaUsers } from 'react-icons/fa';
const AddSalesOrder = ({ t, edit, order }) => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [searchTextItems, setSearchTextItems] = useState('');
  const [openTask, setOpenTask] = useState(false);
  const [searchTextCostCenter, setSearchTextCostCenter] = useState('');
  const [searchTextPriceList, setSearchTextPriceList] = useState('');
  const [loadingTaxesDetails, setLoadingTaxesDetails] = useState(false);
  const [selectName, setSelectName] = useState(null);
  const [dataStatus, setDataStatus] = useState(null);
  const [submitButton, setSubmitButton] = useState(false);
  const [taxesDetails, setTaxesDetails] = useState([]);
  const [open, setOpen] = useState(false);
  const [totalValue, setTotalValue] = useState(0);
  const [dataSourcePayment, setDataSourcePayment] = useState([
    {
      due_date: dayjs(),
      invoice_portion: 100,
    },
  ]);
  const [priceListSelect, setPriceListSelect] = useState('Standard Selling');
  const { id, idOrder } = useParams();

  const [dataSource, setDataSource] = useState([
    {
      warehouse: form.getFieldValue('set_warehouse'),
      schedule_date: dayjs(),
    },
  ]);
  const [dataSourceSalesTeam, setDataSourceSalesTeam] = useState([
    {
      allocated_percentage: 100,
    },
  ]);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const { companyName, currentLang } = useSelector((state) => state.user);
  const client = useQueryClient();
  const { message } = App.useApp();
  const [loadingAdd, setLoadingAdd] = useState(false);
  const [searchtextCustomer, setSearchtextCustomer] = useState('');
  const { mutate: onAddPurchaseOrder } = useMutation({
    mutationKey: ['addSalesOrder'],
    mutationFn: (body) =>
      edit ? updateSalesOrder(body, id) : addSalesOrder(body),
    onSuccess: (data) => {
      setLoadingAdd(false);
      console.log(data?.message, 'datawwww');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      setSelectName(edit ? id : data?.data?.name);
      setSubmitButton(true);
      message.success(edit ? 'Updated successfully' : 'Added successfully');
      client.invalidateQueries({ queryKey: [queryKeys.getSalesOrder] });
      // form.resetFields();
      edit && dataStatus !== 0 && navigate('/sales-order');
    },
    onError: (error) => {
      setLoadingAdd(false);
      // message.error(error.response.data._server_messages);
      const serverMessages = JSON.parse(error.response.data._server_messages);
      const messageData = JSON.parse(serverMessages[0]);
      const title = messageData.title || 'Error';
      const messageContent = messageData.message || 'An error occurred';
      message.error({
        content: `${title}: ${messageContent.replace(/<[^>]*>/g, '')}`,
        duration: 5,
      });
      console.log('error:', error);
    },
  });
  const {
    data: purchaseOrderDetails,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: [queryKeys.getSalesOrder, id],
    queryFn: () => getSalesOrderById(id),
    enabled: !!edit,
  });
  const { data: costCenters } = useQuery({
    queryKey: [queryKeys.getCostCentersSearch, searchTextCostCenter],
    queryFn: () => getSearchPatients('Cost Center', searchTextCostCenter),
    enabled:
      searchTextCostCenter?.length >= 2 || searchTextCostCenter?.length === 0,
    keepPreviousData: true,
  });
  const { mutate: onGetTaxes, data: taxesList } = useMutation({
    mutationFn: (name) => getVATDetails('Sales', name),
    onSuccess: (data) => {
      console.log(data, 'data');
      setLoadingTaxesDetails(false);
      setTaxesDetails(data?.message);
    },
    onError: (error) => {
      console.log(error, 'error');
    },
  });
  const handleSubmit = useMutation({
    mutationFn: (id) => submitMaterialRequest('Sales Order', id),
    onSuccess: (data) => {
      console.log(data, 'data');
      setLoadingAdd(false);
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      submitButton && navigate('/sales-order');
      message.success(data?.message?.message || 'Submitted successfully');
      client.invalidateQueries({ queryKey: [queryKeys.getSalesOrder, id] });
    },
    onError: () => {
      message.error('Something went wrong');
    },
  });
  const handleCancle = useMutation({
    mutationFn: (id) => cancelMaterialRequest('Sales Order', id),
    onSuccess: (data) => {
      console.log(data, 'data');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(data?.message?.message || 'Cancled successfully');
      navigate('/sales-order');
    },
    onError: () => {
      message.error('Something went wrong');
    },
  });
  const netTotalWatch = Form.useWatch('total', form);
  const disableRoundedTotalWatch = Form.useWatch('disable_rounded_total', form);

  useEffect(() => {
    if (taxesList || dataSource) {
      const netTotal = form.getFieldValue('total');
      const disableRoundedTotal = form.getFieldValue('disable_rounded_total');
      const totalRate = taxesList?.message?.reduce(
        (sum, item) => sum + item?.rate,
        0
      );
      const taxAmount = (netTotal * totalRate) / 100;
      const grandTotal = netTotal + taxAmount;
      const roundedTotal = disableRoundedTotal
        ? Math.round(grandTotal)
        : grandTotal;
      const roundingAdjustment = (roundedTotal - grandTotal).toFixed(2);
      setDataSourcePayment(
        dataSourcePayment.map((item) => ({
          ...item,
          payment_amount: roundedTotal,
          invoice_portion: item.payment_amount || 100,
        }))
      );
      form.setFieldsValue({
        grand_total: grandTotal,
        total_taxes_and_charges: taxAmount,
        rounded_total: roundedTotal,
        rounding_adjustment: roundingAdjustment,
      });
    }
  }, [taxesList, form, dataSource, netTotalWatch, disableRoundedTotalWatch]);

  const { data: warehouse } = useQuery({
    queryKey: [queryKeys.getWarehouse],
    queryFn: () =>
      getWarehouse({
        key: '',
        value: '',
      }),
    keepPreviousData: true,
  });
  const { data: itemsList } = useQuery({
    queryKey: [queryKeys.getSearchApiIsStock, searchTextItems],
    queryFn: () => getSearchPatients('Item', searchTextItems),
    keepPreviousData: true,
    enabled: searchTextItems?.length >= 3 || searchTextItems?.length === 0,
  });
  const { data: priceList } = useQuery({
    queryKey: [queryKeys.getPriceListSearch, searchTextPriceList],
    queryFn: () => getSearchPatients('Price List', searchTextPriceList),
    enabled:
      searchTextPriceList?.length >= 3 || searchTextPriceList?.length === 0,
    keepPreviousData: true,
  });
  const { data: taxesCharges } = useQuery({
    queryKey: [queryKeys.getItemTaxTemplate],
    queryFn: () => getSearchApi('Sales Taxes and Charges Template'),
    keepPreviousData: true,
  });
  useEffect(() => {
    if (edit) {
      refetch();
    }
  }, [edit, refetch]);

  useEffect(() => {
    if (edit && purchaseOrderDetails) {
      setDataStatus(purchaseOrderDetails?.data?.docstatus);
      setTaxesDetails(purchaseOrderDetails?.data?.taxes);
      setDataSourceSalesTeam(purchaseOrderDetails?.data?.sales_team || [{}]);
      onGetTaxes(purchaseOrderDetails?.data?.taxes_and_charges);
      setDataSourcePayment(
        purchaseOrderDetails?.data?.payment_schedule?.length
          ? purchaseOrderDetails?.data?.payment_schedule?.map((payment) => ({
              ...payment,
              due_date: dayjs(payment?.due_date),
              invoice_portion: Number(payment?.invoice_portion || 100),
            }))
          : [{}]
      );
      setDataSource(
        purchaseOrderDetails?.data?.items?.map((item) => ({
          ...item,
          schedule_date: dayjs(item?.schedule_date),
        })) || [{}]
      );
      form.setFieldsValue({
        ...purchaseOrderDetails?.data,
        base_rounded_total: Number(
          purchaseOrderDetails?.data?.base_rounded_total
        ),
        grand_total: Number(purchaseOrderDetails?.data?.grand_total),
        rounding_adjustment: Number(
          purchaseOrderDetails?.data?.rounding_adjustment
        ),
        rounded_total: Number(purchaseOrderDetails?.data?.rounded_total),
        disable_rounded_total: Number(
          purchaseOrderDetails?.data?.disable_rounded_total
        ),
        base_discount_amount: Number(
          purchaseOrderDetails?.data?.base_discount_amount
        ),
        additional_discount_percentage: Number(
          purchaseOrderDetails?.data?.additional_discount_percentage
        ),
        ignore_pricing_rule: purchaseOrderDetails?.data.ignore_pricing_rule
          ? 1
          : 0,
        transaction_date: dayjs(purchaseOrderDetails?.data?.transaction_date),
        delivery_date: dayjs(purchaseOrderDetails?.data?.delivery_date),
        schedule_date: dayjs(purchaseOrderDetails?.data?.schedule_date),
        // payment_schedule: dataSourcePayment?.map((payment) => ({ ...payment, due_date:dayjs(payment?.due_date).format('YYYY-MM-DD')})),
        // payment_schedule: purchaseOrderDetails?.data?.payment_schedule?.map((payment) => ({ ...payment, due_date:dayjs(payment?.due_date)})) || [{}],
      });
    } else {
      form.resetFields();
    }
  }, [edit, purchaseOrderDetails, form]);
  const onFinish = (values) => {
    const totalPortion = dataSourcePayment?.reduce(
      (acc, curr) => acc + Number(curr?.invoice_portion),
      0
    );
    if (totalPortion !== 100) {
      return message.error('Total portion should be 100%');
    }
    setLoadingAdd(true);
    onAddPurchaseOrder({
      ...values,
      company: companyName,
      conversion_rate: 1,
      disable_rounded_total: values?.disable_rounded_total ? 1 : 0,
      plc_conversion_rate: 1,
      base_rounded_total: 0,
      base_discount_amount: Number(values?.base_discount_amount),
      additional_discount_percentage: Number(
        values?.additional_discount_percentage
      ),
      sales_team: dataSourceSalesTeam[0]?.sales_person
        ? dataSourceSalesTeam?.map((team) => ({
            ...team,
            allocated_percentage: Number(team?.allocated_percentage),
            allocated_amount: Number(team?.allocated_amount),
            incentives: Number(team?.incentives),
          }))
        : [],
      total_taxes_and_charges: Number(values?.total_taxes_and_charges),
      grand_total: Number(values?.grand_total),
      rounding_adjustment: Number(values?.rounding_adjustment),
      rounded_total: Number(values?.rounded_total),
      disable_rounded_total: Number(values?.disable_rounded_total),
      ignore_pricing_rule: values.ignore_pricing_rule ? 1 : 0,
      transaction_date: dayjs(values?.transaction_date).format('YYYY-MM-DD'),
      delivery_date: dayjs(values?.delivery_date).format('YYYY-MM-DD'),
      schedule_date: dayjs(values?.schedule_date).format('YYYY-MM-DD'),
      items: dataSource?.map((item) => ({
        ...item,
        schedule_date: dayjs(item?.schedule_date).format('YYYY-MM-DD'),
      })),
      taxes: taxesList?.message?.map((tax) => ({ ...tax })),
      payment_schedule: dataSourcePayment?.map((payment) => ({
        invoice_portion: Number(payment?.invoice_portion || 100),
        due_date: dayjs(payment?.due_date).format('YYYY-MM-DD'),
        discount: Number(payment?.discount),
        payment_amount: Number(payment?.payment_amount || 0),
        outstanding: Number(payment?.outstanding || 0),
        paid_amount: Number(payment?.paid_amount || 0),
        discounted_amount: Number(payment?.discounted_amount),
        base_payment_amount: Number(payment?.base_payment_amount),
        description: payment?.description,
      })),
    });
  };
  const { mutate: handleGetDetails } = useMutation({
    mutationKey: [queryKeys.getSearchApiAccountList],
    mutationFn: (values) =>
      getGetDetailsApi({
        type: 'Customer',
        name: values,
        // fields: ['customer_name_in_arabic', 'customer_name', 'tax_id'],
        fields: ['customer_name', 'tax_id', 'custom_vat_registration_number'],
      }),
    onSuccess: (data) => {
      form.setFieldsValue({
        // customer_name_in_arabic: data?.message?.customer_name_in_arabic,
        customer_name: data?.message?.customer_name,
        custom_vat_registration_number:
          data?.message?.custom_vat_registration_number,
        tax_id: data?.message?.tax_id,
      });
    },
  });
  const { data: customer } = useQuery({
    queryKey: [queryKeys.getSearchApiAccountList, searchtextCustomer],
    queryFn: () =>
      getSearchApiSearchText({
        type: 'Customer',
        searchTxt: searchtextCustomer,
      }),
    keepPreviousData: true,

    enabled:
      searchtextCustomer?.length >= 3 || searchtextCustomer?.length === 0,
  });
  const disountApplyType = Form.useWatch('discount_type', form);
  const items = (record) => [
    {
      key: '2',
      label: t.materialRequest,
      icon: <FileTextOutlined />,
      onClick: () => navigate(`/sales-order/material-request/${record?.name}`),
      disabled: record?.docstatus === 1 ? false : true,
    },
    {
      key: '2-1',
      label: t.salesInvoice,
      icon: <FaFileInvoice />,
      onClick: () => navigate(`/sales-invoice-order/${record?.name}`),
      // disabled: record?.docstatus === 1 ? false : true,
    },
    {
      type: 'divider',
    },
    // {
    //   key: '3',
    //   label: t.CreateDownPaymentInvoice,
    //   icon: <DollarOutlined />,
    //   onClick: () => {
    //     setOpen(true);
    //     setTotalValue(record?.total);
    //   },
    // },
    // {
    //   key: '4',
    //   label: t.CreateFullPaymentInvoice,
    //   icon: <DollarOutlined />,
    //   onClick: () =>
    //     navigate(`/sales-order/sales-invoice-full-payment/${record?.name}`),
    // },
    {
      key: '5',
      label: t.paymentEntry,
      icon: <FileTextOutlined />,
      onClick: () => navigate(`/sales-order/payment-entry/${record?.name}`),
    },
    {
      key: '77',
      label: t.AssignTask,
      icon: <MdAssignmentAdd />,
      onClick: () => {
        setOpenTask(true);
      },
    },
    {
      type: 'divider',
    },
    {
      key: '6',
      label: t.submit,
      icon: <CheckOutlined />,
      onClick: () => handleSubmit.mutate(record?.name),
      disabled: record?.docstatus === 0 ? false : true,
    },
    {
      key: '7',
      label: t.Cancel,
      icon: <CloseCircleOutlined />,
      onClick: () => handleCancle.mutate(record?.name),
      disabled: record?.docstatus === 1 ? false : true,
    },
  ];
  if (isLoading) {
    return (
      <div
        style={{
          width: '100%',
          height: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Spin size="large" />
      </div>
    );
  }
  return (
    <>
      {/* <Heading
        title={t.salesOrder}
        subTitle={edit ? t.editSalesOrder : t.addSalesOrder}
        path="/sales-order"
      /> */}
      <HeadingApp
        nameTab={t.SalesFinance}
        title={t.salesOrder}
        subTitle={edit ? t.editSalesOrder : t.addSalesOrder}
        icon={<FaCartPlus />}
      />
      <Card style={{ borderRadius: '0px' }}>
        <Flex justify="end" align="center">
          {edit && (
            <Dropdown
              menu={{ items: items(purchaseOrderDetails?.data) }}
              trigger={['click']}
              arrow
              // onClick={() => setStatus(record)}
            >
              <Button size="small" type="text" className="btn-light">
                {t.action}
                <DownOutlined />
              </Button>
            </Dropdown>
          )}
        </Flex>
        <Form
          form={form}
          name="add-purchase-order"
          layout="vertical"
          onFinish={onFinish}
          initialValues={{
            taxes: [{}],
            payment_schedule: [{}],
            items: [{}],
          }}
          style={{
            marginTop: '20px',
          }}
        >
          <Row gutter={[16, 0]}>
            <Col xs={24} md={24} lg={18}>
              <Row gutter={[16, 0]}>
                <Col xs={24} md={12} xl={12} xxl={12}>
                  <Form.Item
                    name="customer"
                    label={t.Customer}
                    rules={[{ required: true }]}
                  >
                    <Select
                      placeholder={t.Customer}
                      style={{ width: '100%' }}
                      showSearch
                      filterOption={false}
                      popupMatchSelectWidth={false}
                      // options={customer?.message?.map((item) => ({
                      //   value: item?.value,
                      //   label: item?.value,
                      // }))}
                      onChange={(value) => {
                        handleGetDetails(value);
                      }}
                      onSearch={(value) => setSearchtextCustomer(value)}
                    >
                      {customer?.message?.map((item) => (
                        <Select.Option key={item?.value}>
                          <Flex gap={1} vertical>
                            <span>{item?.value}</span>
                            <span
                              className="item-description"
                              style={{ fontSize: '11px', color: 'gray' }}
                            >
                              {item?.description}
                            </span>
                          </Flex>
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                {/* <Col xs={24} md={12} xl={12} xxl={12}>
                  <Form.Item
                    name="customer_name_in_arabic"
                    label={t.customerNameInArabic}
                    rules={[{ required: true }]}
                  >
                    <Input placeholder={t.customerNameInArabic} disabled />
                  </Form.Item>
                </Col> */}
                {/* <Col xs={24} md={12} xl={12} xxl={12}>
                  <Form.Item name="tax_id" label={t.taxId}>
                    <Input placeholder={t.taxId} disabled />
                  </Form.Item>
                </Col> */}
                {/* <Col xs={24} md={12} xl={12} xxl={12}>
                  <Form.Item
                    name="custom_vat_registration_number"
                    label={t.custom_vat_registration_number}
                  >
                    <Input
                      placeholder={t.custom_vat_registration_number}
                      disabled
                    />
                  </Form.Item>
                </Col> */}
                <Col xs={24} md={12} xl={12} xxl={12}>
                  <Form.Item
                    name="transaction_date"
                    label={t.transactionDate}
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                    initialValue={dayjs()}
                  >
                    <DatePicker
                      style={{ width: '100%' }}
                      placeholder={t.transactionDate}
                      format="YYYY-MM-DD"
                      disabledDate={(current) =>
                        current.endOf('d').valueOf() <
                        dayjs().endOf('d').valueOf()
                      }
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={12} xxl={12}>
                  <Form.Item
                    name="delivery_date"
                    label={t.deliveryDate}
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                    initialValue={dayjs()}
                  >
                    <DatePicker
                      style={{ width: '100%' }}
                      placeholder={t.deliveryDate}
                      format="YYYY-MM-DD"
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={12} xxl={12}>
                  <Form.Item
                    name="schedule_date"
                    label={t.scheduleDate}
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                    initialValue={dayjs()}
                  >
                    <DatePicker
                      style={{ width: '100%' }}
                      placeholder={t.scheduleDate}
                      format="YYYY-MM-DD"
                    />
                  </Form.Item>
                </Col>

                {/* <Divider orientation="left" >
              {t.accountingDimensions}
            </Divider> */}
                <Divider orientation="left">{t.currencyAndPriceList}</Divider>
                {/* <Col xs={12} md={8} xl={12} xxl={12}>
              <Form.Item
                name="currency"
                label={t.currency}
                rules={[
                  {
                    required: true,
                  },
                ]}
                initialValue={'SAR'}
              >
                <Input placeholder={t.currency} disabled />
              </Form.Item>
            </Col> */}
                <Col xs={24} md={12} xl={12} xxl={12}>
                  <Form.Item
                    name="buying_price_list"
                    label={t.PriceList}
                    initialValue={'Standard Selling'}
                    // rules={[{ required: true }]}
                  >
                    <Select
                      placeholder={t.PriceList}
                      showSearch
                      optionFilterProp="children"
                      filterOption={false}
                      onSearch={(value) => {
                        setSearchTextPriceList(value);
                      }}
                      onChange={(value, option) => {
                        setPriceListSelect(value);
                        form.setFieldsValue({
                          price_list_currency: option?.option?.description,
                        });
                      }}
                      options={priceList?.message?.map((item) => ({
                        value: item?.value,
                        label: item?.value,
                        option: item,
                      }))}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={12} xxl={12}>
                  <Form.Item
                    name="cost_center"
                    label={t.costCenter}
                    style={{ width: '100%', marginBottom: '0px' }}
                  >
                    <Select
                      placeholder={t.costCenter}
                      showSearch
                      optionFilterProp="children"
                      filterOption={false}
                      onSearch={(value) => {
                        setSearchTextCostCenter(value);
                      }}
                      options={costCenters?.message?.map((item) => ({
                        value: item?.value,
                        label: item?.value,
                      }))}
                    />
                  </Form.Item>
                </Col>
                <Col
                  xs={24}
                  md={12}
                  xl={8}
                  xxl={8}
                  style={{
                    display: 'flex',
                    justifyContent: 'start',
                    alignItems: 'center',
                  }}
                >
                  <Form.Item
                    name="disable_rounded_total"
                    label={t.disableRoundedTotal}
                    valuePropName="checked"
                    layout="horizontal"
                    className="margin-bottom-0"
                  >
                    <Checkbox />
                  </Form.Item>
                </Col>

                <Divider orientation="left">{t.items}</Divider>
                <Col xs={24} md={12} xl={12} xxl={12}>
                  <Form.Item
                    name="set_warehouse"
                    label={t.setWarehouse}
                    // rules={[
                    //   {
                    //     required: true,
                    //   },
                    // ]}
                  >
                    <Select
                      placeholder={t.setWarehouse}
                      style={{ width: '100%' }}
                      popupMatchSelectWidth={false}
                      onChange={(value) => {
                        setDataSource(
                          dataSource.map((item) => {
                            return {
                              ...item,
                              warehouse: value,
                            };
                          })
                        );
                      }}
                      options={warehouse?.data?.map((item) => ({
                        value: item?.name,
                        label: item?.warehouse_name,
                      }))}
                    />
                  </Form.Item>
                </Col>
                <Col span={24} style={{ marginBottom: '20px' }}>
                  <ItemOrderList
                    type="Purchase Order"
                    keyData="Sales Order"
                    priceList={priceListSelect}
                    setSelectedIndex={setSelectedIndex}
                    selectedIndex={selectedIndex}
                    dataSource={dataSource}
                    setDataSource={setDataSource}
                    form={form}
                    itemsList={itemsList}
                    setSearchTextItems={setSearchTextItems}
                    warehouse={warehouse}
                    t={t}
                  />
                </Col>

                <Divider orientation="left">{t.TaxesandCharges}</Divider>
                <Col xs={24} md={12} xl={12} xxl={12}>
                  <Form.Item
                    name="taxes_and_charges"
                    label={t.TaxesandCharges}
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Select
                      placeholder={t.TaxesandCharges}
                      style={{ width: '100%' }}
                      popupMatchSelectWidth={false}
                      onChange={(value) => {
                        setLoadingTaxesDetails(true);
                        onGetTaxes(value);
                      }}
                      options={taxesCharges?.message?.map((item) => ({
                        value: item?.value,
                        label: item?.value,
                      }))}
                    />
                  </Form.Item>
                </Col>

                <Col span={24}>
                  <TaxtList
                    t={t}
                    form={form}
                    data={taxesDetails}
                    loadingTaxesDetails={loadingTaxesDetails}
                  />
                </Col>
                <Divider orientation="left">{t.paymentSchedule}</Divider>
                <Col span={24}>
                  <PaymentSchedule
                    dataSourcePayment={dataSourcePayment}
                    setDataSourcePayment={setDataSourcePayment}
                    t={t}
                    form={form}
                    type="Order"
                  />
                </Col>
                <Divider orientation="left">{t.SalesTeam}</Divider>
                <Col span={24}>
                  <SalesTeamList
                    setDataSource={setDataSourceSalesTeam}
                    dataSource={dataSourceSalesTeam}
                    t={t}
                    form={form}
                  />
                </Col>
                <Divider />

                <Col xs={24} md={12} xl={12} xxl={12}>
                  <Form.Item
                    name="total"
                    label={t.Total}
                    // rules={[
                    //   {
                    //     required: true,
                    //   },
                    // ]}
                  >
                    <Input
                      placeholder={t.Total}
                      type="number"
                      min={0}
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={12} xxl={12}>
                  <Form.Item
                    name="total_qty"
                    label={t.totalQty}
                    // rules={[
                    //   {
                    //     required: true,
                    //   },
                    // ]}
                  >
                    <Input
                      placeholder={t.totalQty}
                      type="number"
                      min={0}
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={12} xxl={12}>
                  <Form.Item
                    name="total_taxes_and_charges"
                    label={t.TotalTaxesandCharges}
                    // rules={[
                    //   {
                    //     required: true,
                    //   },
                    // ]}
                  >
                    <Input
                      placeholder={t.TotalTaxesandCharges}
                      type="number"
                      min={0}
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={12} xxl={12}>
                  <Form.Item
                    name="grand_total"
                    label={t.grandTotal}
                    // rules={[
                    //   {
                    //     required: true,
                    //   },
                    // ]}
                  >
                    <Input
                      placeholder={t.grandTotal}
                      type="number"
                      min={0}
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={12} xxl={12}>
                  <Form.Item
                    name="rounding_adjustment"
                    label={t.roundingAdjustment}
                  >
                    <Input
                      placeholder={t.roundingAdjustment}
                      type="number"
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={12} xxl={12}>
                  <Form.Item
                    name="rounded_total"
                    label={t.roundedTotal}
                    // rules={[
                    //   {
                    //     required: true,
                    //   },
                    // ]}
                    disabled
                  >
                    <Input
                      placeholder={t.roundedTotal}
                      type="number"
                      min={0}
                      disabled
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} xl={12} xxl={12}>
                  <Form.Item
                    name="apply_discount_on"
                    label={t.applyDiscountOn}
                    // rules={[
                    //   {
                    //       required: true,
                    //     },
                    // ]}
                  >
                    <Select
                      placeholder={t.applyDiscountOn}
                      options={[
                        {
                          value: 'Grand Total',
                          label: t.GrandTotal,
                        },
                        {
                          value: 'Net Total',
                          label: t.netTotal,
                        },
                      ]}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={12} xxl={12}>
                  <Form.Item
                    name="discount_type"
                    label={t.discountType}
                    // rules={[
                    //   {
                    //     required: true,
                    //   },
                    // ]}
                  >
                    <Select
                      placeholder={t.discountType}
                      style={{ width: '100%' }}
                      options={[
                        {
                          value: 'Percentage',
                          label: t.percentage,
                        },
                        {
                          value: 'Amount',
                          label: t.amount,
                        },
                      ]}
                    />
                  </Form.Item>
                </Col>
                {disountApplyType === 'Amount' && (
                  <Col xs={24} md={12} xl={12} xxl={12}>
                    <Form.Item name="base_discount_amount" label={t.value}>
                      <Input
                        placeholder={t.value}
                        type="number"
                        // disabled
                      />
                    </Form.Item>
                  </Col>
                )}
                {disountApplyType === 'Percentage' && (
                  <Col xs={24} md={12} xl={12} xxl={12}>
                    <Form.Item
                      name="additional_discount_percentage"
                      label={t.value}
                    >
                      <Input
                        placeholder={t.value}
                        type="number"
                        // disabled
                      />
                    </Form.Item>
                  </Col>
                )}
              </Row>
              <div className="form-btns">
                <Button
                  type="primary"
                  ghost
                  onClick={() => {
                    navigate(-1);
                  }}
                >
                  {t.Cancel}
                </Button>
                <Button
                  type="primary"
                  // htmlType="submit"
                  // block
                  onClick={() => {
                    if (submitButton) {
                      setLoadingAdd(true);
                      handleSubmit.mutate(selectName);
                    } else {
                      form.submit();
                    }
                  }}
                  loading={loadingAdd}
                >
                  {/* {edit ? t.edit : t.submit} */}
                  {submitButton ? t.submit : edit ? t.edit : t.Save}
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
        <ModalAddAmount
          t={t}
          open={open}
          setOpen={setOpen}
          id={id}
          setTotalValue={setTotalValue}
          totalValue={totalValue}
        />
        <ModalTodoList
          open={openTask}
          setOpen={setOpenTask}
          editId={id}
          doctype="Sales Order"
          t={t}
        />
      </Card>
    </>
  );
};

export default AddSalesOrder;
